export default __webpack_public_path__ + "static/media/Front-Zeus-Gym.76ac0595.jpg";